// src/components/About.tsx
"use client"

import type React from "react"
import { Container, Typography, Box } from "@mui/material"
import { Link } from "@mui/material"
import { motion } from "framer-motion"


const About: React.FC = () => {
  return (
    <div style={{ backgroundColor: '#001f3f', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '80px' }}>
      <Container maxWidth="md" style={{ backgroundColor: 'beige', color: '#021526', padding: '40px', borderRadius: '8px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)' }}>
      <motion.div initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <Typography variant="h4" component="h1" gutterBottom style={{ color: "#001f3f", textAlign: "center" }}>
            About
          </Typography>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Box mb={3}>
            <Typography variant="body1" paragraph>
              Hey everyone, I'm <strong>Neel</strong>. I originally created this app with the hope of helping students
              in my community stay focused and productive. But as I worked on it, I realized that distractions are
              something we all struggle with—whether we're studying, working, or just trying to get things done. So, I
              built this website to make this tool available to everyone.
            </Typography>
            <Typography>
              <strong>What inspired me: </strong>
            </Typography>
            <Typography variant="body1" paragraph>
              As a student, I've struggled with staying focused. Whether it's notifications from my phone, background
              noise, or simply wandering thoughts, maintaining concentration for long periods often feels like an uphill
              battle. That's why I created this application—not just for myself, but for everyone who faces the same
              challenges, especially for those with ADHD.
            </Typography>
            <Typography variant="body1" paragraph>
              In today's world, distractions are everywhere, pulling our attention in countless directions. But I
              believe that with the right tools, we can reclaim our focus and reach our goals. This app is designed to
              be a simple yet powerful way to help you stay mindful of your distractions and get back on track quickly.
            </Typography>
            <Typography variant="body1" paragraph>
              My hope is that this app will serve as a companion for students, professionals, and anyone who wants to
              sharpen their focus and make the most of their time. With each session, my aim is for you to feel a little
              more in control, a little more focused, and a little closer to finishing each and every one of your tasks.
            </Typography>
            <Typography variant="body1" paragraph>
              This isn't just an app—it's a commitment to growth, resilience, and focus in a world full of distractions.
              Thank you for trying this app, and I hope it brings you the clarity and productivity you're looking for.
            </Typography>
            <Typography variant="body1">
              Feel free to add me on LinkedIn:{" "}
              <Link
                href="https://www.linkedin.com/in/neel-majmudar-n091"
                target="_blank"
                style={{ color: "#6EACDA", fontWeight: "bold" }}
              >
                Here
              </Link>
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </div>
  )
}

export default About

